import React from 'react';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
// import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';

@inject('createTutorialStore')
@observer
export default class QuestionsQuiz extends React.Component {

  state = {
    current_question_idx: 0,
    cpd_quiz: [
      {
        question: '',
        correct: ''
      }
    ]
  }

  componentDidMount() {
    setTimeout(this.setQuiz, 1000);
  }

  setQuiz = () => {
    const { spd_quizzes } = this.props.createTutorialStore.tutorial;

    if(spd_quizzes)
      this.setState({ cpd_quiz: spd_quizzes });
  }

  handleClickQuestion = (e) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      current_question_idx: (e.target.innerText - 1)
    });
  }

  handleChange = (e, value) => {
    const { current_question_idx, cpd_quiz } = this.state;

    let newQuiz = [...cpd_quiz];
    let currentQuestionObj = newQuiz[current_question_idx];
    currentQuestionObj[e.target.name] = value;
    newQuiz[current_question_idx] = currentQuestionObj;
    if (currentQuestionObj.question.length && currentQuestionObj.correct.length && (newQuiz.length == (current_question_idx + 1) && newQuiz.length != 10)) {
      newQuiz = [...newQuiz, { question: '', correct: '' }]
    }
    this.setState({
      ...this.state,
      cpd_quiz: newQuiz
    });

    this.props.createTutorialStore.handleChangeQuiz(newQuiz);
  }

  checkInactiveError = (index, error) => {
    const isError = error.spd_quizzes.filter(e => e.i === index);

    return !_.isEmpty(isError);
  }

  render() {
    const { onAnswerEdit, error } = this.props;
    const { current_question_idx, cpd_quiz } = this.state;
    let errors = this.props.getErrorToQuiz(current_question_idx);

    return (
      <div className="quiz-create-container">
        <h3>Questions Quiz</h3>
        <div className="question-circles-row">
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 0 }, { error: error && this.checkInactiveError(0, error) })}>1</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 1 }, { error: error && this.checkInactiveError(1, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[1] })} disabled={!cpd_quiz[1]}>2</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 2 }, { error: error && this.checkInactiveError(2, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[2] })} disabled={!cpd_quiz[2]}>3</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 3 }, { error: error && this.checkInactiveError(3, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[3] })} disabled={!cpd_quiz[3]}>4</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 4 }, { error: error && this.checkInactiveError(4, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[4] })} disabled={!cpd_quiz[4]}>5</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 5 }, { error: error && this.checkInactiveError(5, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[5] })} disabled={!cpd_quiz[5]}>6</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 6 }, { error: error && this.checkInactiveError(6, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[6] })} disabled={!cpd_quiz[6]}>7</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 7 }, { error: error && this.checkInactiveError(7, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[7] })} disabled={!cpd_quiz[7]}>8</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 8 }, { error: error && this.checkInactiveError(8, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[8] })} disabled={!cpd_quiz[8]}>9</button>
          <button onClick={this.handleClickQuestion} className={classNames('question-circle', { active: current_question_idx == 9 }, { error: error && this.checkInactiveError(9, error) }, { disabledError: error && error.spd_quizzes[0].title && !cpd_quiz[9] })} disabled={!cpd_quiz[9]}>10</button>
        </div>

        <div className="quiz-question-wrapper">
          <TextField
            onChange={onAnswerEdit ? onAnswerEdit : this.handleChange}
            className='quiz-question'
            name="question"
            errorText={errors.question}
            value={cpd_quiz[current_question_idx].question || ''}
            floatingLabelText="Question #"
            type="text"
            style={{ width: '100%' }}
          />
          <RadioButtonGroup
            name="correct"
            onChange={this.handleChange}
            valueSelected={cpd_quiz[current_question_idx].correct.toString()}
            className='select-answer-wrapper'
          >
            <RadioButton
              value="true"
              label="TRUE"
              style={{ marginRight: 50, width: 'unset' }}
            //checked={cpd_quiz[current_question_idx].correct === 'true' || false}
            />
            <RadioButton
              value="false"
              label="FALSE"
            //checked={cpd_quiz[current_question_idx].correct === 'false' || false}
            />
          </RadioButtonGroup>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/tutorial_popup/QuestionsQuiz.js